import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/bi/Loading";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bi-canvas"><Loading label="Starting Eazy Analytics" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
